import { connect } from 'react-redux'

import {
  fetchInitialData,
} from '../actions'

import LogComponent from '../components/LogComponent'

const mapStateToProps = (state) => {
  return {
    log: state.log,
  }
}

const mapDispatchToProps = (dispatch) => ({
  fetchData: () => dispatch(fetchInitialData()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LogComponent)
